import { defineGroupFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

// Funding Info is a group filter - clicking it shows child filters in a submenu
export const fundingInfoDescriptor = defineGroupFilter({
  definition: {
    id: FilterId.FUNDING_INFO,
    name: 'Funding Info',
    type: FilterType.GROUP,
    isVisible: true,
    children: [
      FilterId.FUNDING_STAGE,
      FilterId.VALUATION,
      FilterId.LAST_FUNDING_AMOUNT,
      FilterId.TOTAL_FUNDING_AMOUNT,
      FilterId.LAST_FUNDING_YEAR,
    ],
  },
});
